import { render, staticRenderFns } from "./DZ.vue?vue&type=template&id=4066b38c&scoped=true"
import script from "./DZ.vue?vue&type=script&lang=js"
export * from "./DZ.vue?vue&type=script&lang=js"
import style0 from "./DZ.vue?vue&type=style&index=0&id=4066b38c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4066b38c",
  null
  
)

export default component.exports